// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"25":"token","146":"match","497":"config","535":"login","803":"train"}[chunkId] + "." + {"25":"a881ab0b","146":"962bf42d","497":"e68dd5dc","535":"e68b9841","803":"2dd5b9af"}[chunkId] + ".css";
};